import styled from 'styled-components'
import CommonButton from 'components/Button/CommonButton'
import theme from 'theme_'
import { WhiteBlock } from 'components/Layout'

export const JobImagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const JobImagesHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const JobImagesSpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 164px;
`
export const JobImagesBlock = styled(WhiteBlock)`
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 24px;
  color: ${theme.colors.menuDark};
  height: 164px;
`

export const JobImagesWrapper = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, 1fr);
  @media ${theme.devices.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
  @media ${theme.devices.tabletLandscape} {
    grid-template-columns: repeat(4, 1fr);
  }
  @media ${theme.devices.desktop} {
    grid-template-columns: repeat(5, 1fr);
  }
`

export const JobImageUploadButton = styled(CommonButton)`
  height: 40px;
  background: transparent;
`

export const JobImagesErrorWrapper = styled.div`
  margin-top: 16px;
  color: ${theme.colors.error};
`
